<template>
	<div ref="homes">
		<div class="fixedbox" :style="{ right: isscroll == 1 ? '-4%' : '0%' }" @click="$router.push('/inits')">
			<i class="icons el-icon-monitor"></i>
			<p>回引导</p>
		</div>

		<div class="flexs headersas" ref="headersas">
			<router-link to="/homesview/homesview" style="color: #fff;font-weight: bold;"><img src="https://www.hngtsd.net:65535/IMAGES/logo.png" alt="" /></router-link>
			<div class="tabesl">
				<div v-for="(item, index) in tablists" :key="index" :class="{ tabeslactive: item.pagepath == activeName }" :name="item.pagepath" @click="handleClick(item)">
					<!-- <router-link :to="item.pagepath">
						{{ item.labels }}
					</router-link> -->
					{{ item.labels }}
				</div>
			</div>
			<!-- <div class="srachs">
				<input type="text" placeholder="请输入您要搜索的内容" />
				<span class="el-icon-search"></span>
			</div> -->
			<div class="logos">
				<div v-if="islogins == 0">
					&nbsp;
					<router-link to="/user/logins">登录</router-link>
					<!-- <a href="/user/logins">登录</a> -->
					| &nbsp;
					<router-link to="/user/register">注册</router-link>
					<!-- <a href="/user/register">注册</a> -->
				</div>
				<div v-if="islogins == 1">
					<span>欢迎回来：</span>
					<img style="width: 30px;height: 30px;border-radius: 50%;margin-right: 5px;" :src="usersobj.ui_photoPath ?? require('@/images/header.png')" alt="" />
					<span @click="gousers()" style="cursor: pointer;">{{ usersobj.ui_realName }}</span>

					<span @click="delectsdf()" style="cursor: pointer;color: #000;margin-left: 10px;font-size: 14px;color: #000 ;">注销</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	function isElementInViewport(el) {
		if (!el) return false;
		var rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
export default {
	name: 'headerers',
	props: {
		tablist: [Object, Array]
	},
	data() {
		return {
			islogins: 0,
			activeName: '/homesview/homesview',
			tablists: [
				{
					name: '云首页',
					labels: '首页',
					pagepath: '/homesview/homesview'
				},
				{ name: '云课程', labels: '云课程', pagepath: '/homesview/cloudcourse' },
				{ name: '资源库', labels: '资源库', pagepath: '/homesview/resource' },
				{ name: '试题库', labels: '试题库', pagepath: '/homesview/trialballoon' },
				// {
				// 	labels: '金砖大赛',
				// 	pagepath: '/homesview/competition'
				// },
				{
					labels: '实训管理',
					pagepath: '/user/logins'
				}
			],
			usersobj: {},
			isscroll: 0
		};
	},
	updated() {
		// console.log(localStorage.getItem('usercenter'), '获取');
	},
	mounted() {
			var self = this;
			document.addEventListener('visibilitychange', this._visibilityHandler = function() {
				self.getlicastorge();
			});
	
			this.getlicastorge();
			this.activeName = this.$route.fullPath;
	
			this._scrollHandler = function() {
				var myBox = document.querySelector('.kcdh_bt');
				if (isElementInViewport(myBox)) {
					self.isscroll = 1;
				} else {
					self.isscroll = 0;
				}
			};
			window.addEventListener('scroll', this._scrollHandler);
		},
		beforeDestroy() {
			document.removeEventListener('visibilitychange', this._visibilityHandler);
			window.removeEventListener('scroll', this._scrollHandler);
		},

	methods: {
		getlicastorge() {
			if (localStorage.getItem('usercenter')) {
				// console.log('有登录', localStorage.getItem('usercenter'));
				this.islogins = 1;
				this.usersobj = JSON.parse(localStorage.getItem('usercenter'));
			} else {
				this.islogins = 0;
			}
		},
		gousers() {
			this.$router.push('/usercenter/usermessage');
		},
		delectsdf() {
			// console.log('退出');
			localStorage.clear('token');
			localStorage.clear('siguid');
			localStorage.clear('uiguid');
			this.$cookie.remove('allbtnlist');
			// this.$cookie.remove('/%password/%');
			this.$cookie.remove('/%sxtrguid/%');
			// this.$cookie.remove('/%name/%');
			this.$cookie.remove('sxsi_guid');
			this.$cookie.remove('Token');

			this.delCookie();
			this.$cookie.remove('Token');
			this.$router.push({
				name: '登录'
			});
		},
		delCookie() {
			var keys = document.cookie.match(/[^ =;]+(?==)/g);
			if (keys) {
				for (var i = keys.length; i--; ) {
					document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.ratingdog.cn
					document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.ratingdog.cn
					document.cookie = keys[i] + '=0;path=/;domain=.test.com;expires=' + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
				}
			}
		},
		handleClick(e) {
			console.log(e,'跳转');
			if (e.labels == '实训管理') {
				let routerurl = {};
				if (this.islogins == 1) {
					// console.log(this.usersobj);
					if (this.usersobj.UserMenuList[0].path == '/usercenter') {
						routerurl = this.$router.resolve({
							path: this.usersobj.UserMenuList[0].children[0].path
						});
					} else {
						routerurl = this.$router.resolve({
							path: this.usersobj.UserMenuList[0].path
						});
					}
					window.open(routerurl.href, '_blank');
				} else {
					routerurl = this.$router.resolve({
						path: e.pagepath
					});
					window.open(routerurl.href, '_blank');
				}
			} else {
				this.$router.push(e.pagepath);
				this.activeName = e.pagepath;
			}
		}
	}
};
</script>

<style scoped lang="less">
.fixedbox {
	position: fixed;
	right: 0%;
	top: 10%;
	cursor: pointer;
	-webkit-transform: translateY(50%);
	-moz-transform: translateY(50%);
	-ms-transform: translateY(50%);
	-o-transform: translateY(50%);
	transform: translateY(50%);
	z-index: 999;
	background-color: #f7f9fa;
	-webkit-box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
	-moz-box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
	box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
	border-radius: 18px 0 0 18px;
	width: 60px;
	padding: 26px 0;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	transition: all 0.57s ease-in-out;
	.icons {
		font-size: 24px;
		margin-bottom: 5px;
	}
}
.fixedbox:hover {
	right: 0% !important;
}

.srachs {
	margin-right: 10px;
	border-bottom: 2px solid #ccc;
	padding-bottom: 3px;

	input {
		width: 120px;
		font-size: 13px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	span {
		font-size: 15px;
	}
}

.headersas {
	min-width: 1230px;
	width: 1230px;
	height: 60px;
	margin: auto;
	background-color: #fff;
	padding-bottom: 5px;
	z-index: 9999;
}

.tabesl {
	width: 40%;
	height: 100%;
	display: flex;
	margin: 0 24px;
	justify-content: space-around;
	align-items: center;

	div {
		font-size: 16px;
		cursor: pointer;
		font-weight: 700;
		color: #000;
	}
}

.tabeslactive {
	color: #0054ff !important;
	border-bottom: 3px solid #0054ff;
	display: flex;
	align-items: center;
	height: 100%;
}

.flexs {
	display: flex;
	align-items: center;
}

.logos {
	margin-left: 40px;

	a:hover {
		color: #0054ff;
	}
}
</style>
